import { Paper, List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import IconButton from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import React from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import useTableButtonStyle from './TableButtonStyle';
import CreateShareLinkButton from './actions-menu-buttons/CreateShareLinkButton';
import DeleteFileSystemNodeButton from './actions-menu-buttons/DeleteFileSystemNodeButton';
import RenameFileSystemNodeButton from './actions-menu-buttons/RenameFileSystemNodeButton';
import EditFileSystemNodeTagsButton from './actions-menu-buttons/EditFileSystemNodeTagsButton';
import { usePermissions } from 'react-admin';

const FileActionsMenu = (props) => {
    const { isDirectory, fileSystemNodePath } = props;
    const classes = useTableButtonStyle();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { permissions } = usePermissions();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
        setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);
    const id = open ? 'file-actions-menu' : undefined;
  
    return (<>
        <IconButton size="small" onClick={handleClick} className={classes.root}>
            <MoreVertIcon size="small"/>
        </IconButton>

        <Popover 
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            >
            <Paper>
                <List component="nav" aria-label="main mailbox folders">
                    { permissions?.has('edit-file-properties') && <RenameFileSystemNodeButton onClick={handleClose} fileSystemNodePath={fileSystemNodePath} /> }
                    { permissions?.has('delete-files') && <DeleteFileSystemNodeButton onClick={handleClose} fileSystemNodePath={fileSystemNodePath} /> }
                    { permissions?.has('edit-file-properties') && <EditFileSystemNodeTagsButton onClick={handleClose} fileSystemNodePath={fileSystemNodePath} /> }
                    {!isDirectory && permissions?.has('share-files') &&
                        <CreateShareLinkButton onClick={handleClose} isDirectory={isDirectory} fileSystemNodePath={fileSystemNodePath} />
                    }
                </List>
            </Paper>
        </Popover>
    </>);
}

export default FileActionsMenu;